// extracted by mini-css-extract-plugin
module.exports = {"container":"CardInfo_container__2KWF7","infected":"CardInfo_infected__3fTd-","recovered":"CardInfo_recovered__29Pg_","deaths":"CardInfo_deaths__1I9sH"};